/* eslint-disable internal-rules/no-store-in-composables */
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import { canHaveGlobalBanner } from '@/global-banner/global-banner.utils';
import { sideNavCollapsedWidth, sideNavExpandedWidth, sideNavCollapsedWidthSmallScreen, topNavHeight } from '@/constants/nav';
import { useWindowSize } from '@vueuse/core';

const FILTER_BAR_AFFIX_STYLES = {
    fixedStyles: {
        right: '0px',
    },
    shouldAffix: true,
};

export function useFixedStyles () {
    const store = useStore();
    const currentRoute = useRoute();

    const isNavExpanded = computed(() => store.state.leftNav.expanded);
    const topBannerHeight = computed(() => store.state.leftNav.topBannerHeight);
    const isTopBannerDismissed = computed(() => store.state.leftNav.isTopBannerDismissed);
    const shouldGlobalBannerShow = computed(() =>
        canHaveGlobalBanner({
            isTopBannerDismissed,
            currentRoute: currentRoute?.name,
        }),
    );
    const pendoPageRightMargin = ref(0);
    const { width: windowWidth } = useWindowSize();

    const leftNavWidth = computed(() => {
        if (windowWidth.value < 992) {
            return sideNavCollapsedWidthSmallScreen;
        }

        return isNavExpanded.value ? sideNavExpandedWidth : sideNavCollapsedWidth;
    });

    const affixStyles = computed(() => {
        const styles = Object.assign({}, FILTER_BAR_AFFIX_STYLES);

        styles.fixedStyles.left = leftNavWidth.value;
        styles.fixedStyles.right = pendoPageRightMargin.value;

        let top = 0;

        top += topNavHeight;

        if (shouldGlobalBannerShow.value) {
            top += topBannerHeight.value;
        }

        if (top !== 0) {
            styles.fixedStyles.top = top;
        }

        return styles;
    });

    const drawerStyles = computed(() => {
        let top = 0;

        top += topNavHeight;

        if (shouldGlobalBannerShow.value) {
            top += topBannerHeight.value;
        }

        return {
            top,
        };
    });

    const setPendoPageRightMargin = (value) => {
        pendoPageRightMargin.value = windowWidth.value - leftNavWidth.value - value;
    };

    return {
        leftNavWidth,
        affixStyles,
        drawerStyles,
        pendoPageRightMargin,

        setPendoPageRightMargin,
    };
}
